import { getPublicInsights } from '@/services/api/did-api/insights-api';
import { useQuery } from 'react-query';

export const useGetPublicInsights = (agentId: string | undefined) => {
    return useQuery({
        queryKey: ['public-insights', agentId],
        queryFn: () => getPublicInsights(agentId as string),
        enabled: !!agentId,
    });
};
